import React, { useState, useEffect } from "react";
import { Dialog, DialogContent } from "@material-ui/core";
import { postDashboardWebApi } from "../../../webApis/apiResource";
import { getAccessToken } from "../../../services/browserStorage";
import { API_ROUTES, API_ROUTES_KEY } from "../../../constants/apiRoutes";
import {
  getImageSizeFromBase64,
  webApiCheck,
} from "../../../services/gatekeeperMethods";
import { getPayloadData } from "../../../constants/apiRequestData";
import { useDispatch } from "react-redux";
import { errorToast } from "../../../modules/actions/toast.action";
import FeedbackForm from "../../components/FeedbackScreen/FeedbackForm/FeedbackForm";
import FeedbackSubmitted from "../../components/FeedbackScreen/FeedbackSubmitted/FeeedbackSubmitted";
import { triggerFeedbackModal } from "../../../modules/actions/modals.action";
import "./FeedbackModal.scss";

//Modal to let user report an issue.
const FeedbackModal = ({ allowEmailInput }) => {
  const [state, setState] = useState({
    screenshot: "",
    message: "message",
    email: "",
  });
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);

  const dispatchAction = useDispatch();

  //Redux dispatch actions.
  const triggerErrorToast = (message) => {
    dispatchAction(errorToast({ data: { message } }));
  };

  const closeFeedbackModal = () => {
    dispatchAction(triggerFeedbackModal());
  };

  //Check if screenshot is valid or not.
  useEffect(() => {
    if (state.screenshot) {
      let fileSizeInMb = getImageSizeFromBase64(state.screenshot);
      if (fileSizeInMb > 2) {
        //If screenshot is not valid, show error and set state to empty.
        triggerErrorToast("Size must not be greater than 2 MB");
        setState({ ...state, screenshot: "" });
      }
    }
  }, [state.screenshot]);

  //Submit handler of the button
  const submitHandler = (state) => {
    let endPoint = API_ROUTES[API_ROUTES_KEY.ISSUE_REPORTER];
    let payload = getPayloadData(API_ROUTES_KEY.ISSUE_REPORTER, true, state);

    //submits the feedback.
    postDashboardWebApi(getAccessToken(), endPoint, payload).then(
      (Response) => {
        if (webApiCheck(Response)) {
          setFeedbackSubmitted(true);
        }
      }
    );
  };

  return (
    <Dialog open={true} classes={{ paper: "feedback-modal" }}>
      <DialogContent>
        {feedbackSubmitted ? (
          <FeedbackSubmitted onClose={closeFeedbackModal} />
        ) : (
          <FeedbackForm
            submitHandler={submitHandler}
            onClose={closeFeedbackModal}
            allowEmailInput={allowEmailInput}
            triggerErrorToast={triggerErrorToast}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default FeedbackModal;
